<template>
    <div class="landing-container">
        <nav-bar v-if="backButtonVisible">
            <div
                slot="left-button"
                class="nav-back-button"
                @click="backToService"
            >
            </div>
        </nav-bar>
        <expired-page v-if="expired"></expired-page>
        <uploaded-page v-else-if="uploaded" :mustLoggedOn="bizConfig.mustLoggedOn"></uploaded-page>
        <finished-page v-else-if="finished"></finished-page>
        <div v-else class="landing">
            <div class="landing-info">
                <span class="landing-info-icon"><img :src="STATUS_ICON_MAP[status]"></span>
                <span class="landing-info-status">状态：{{STATUS_TEXT_MAP[status]}}</span>
                <div class="landing-info-tip">
                    {{remark || DEFAULT_REMARK}}
                </div>
                <span class="landing-info-addition" v-if="canAddInfo && bizConfig.mustLoggedOn">
                    <a href="javascript:void(0)" @click="isAdditionDialogShow = true">补充信息</a>
                </span>
                <view-progress :mustLoggedOn="bizConfig.mustLoggedOn"></view-progress>
            </div>
            <div class="landing-control">
                <sp-button
                    v-if="canEdit"
                    type="primary"
                    @click="onEditClickHandler"
                >
                    修改信息
                </sp-button>
            </div>
            <div v-if="bizConfig.mustLoggedOn" class="landing-control">
                <sp-button
                    v-if="canReFill"
                    type="primary"
                    @click="onReFillClickHandler"
                >
                    重新填写
                </sp-button>
                <sp-button
                    ghost
                    type="dark"
                    @click="onCloseClickHandler"
                >
                    关闭
                </sp-button>
            </div>
            <sp-dialog
                title="补充信息"
                v-model="isAdditionDialogShow"
                :btns="submitdialogBtnConfig.btns"
            >
                <sp-input v-model="addition"></sp-input>
            </sp-dialog>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { Button, Dialog, Input } from '@ks/sharp-ui';
import { postAddition, setInformationFinish } from '@/utils/fetch';
import { getFixedImgUrl } from '@/utils/dynamic-cdn';
import {
    PAGE_STATUS_MAP,
} from '@/utils/constant';
import { exitWebView, setPageTitle } from '@/utils/bridge';
import { toast } from '@/utils/toast';
import ExpiredPage from '@/components/status-page/ExpiredPage.vue';
import UploadedPage from '@/components/status-page/UploadedPage.vue';
import FinishedPage from '@/components/status-page/FinishedPage.vue';
import ViewProgress from '@/components/ViewProgress.vue';
import NavBar from '@/components/NavBar.vue';
const IMAGE_MAP = getFixedImgUrl();
export default {
    name: 'landing',
    components: {
        [Button.name]: Button,
        [Dialog.name]: Dialog,
        [Input.name]: Input,
        ExpiredPage,
        UploadedPage,
        FinishedPage,
        ViewProgress,
        NavBar,
    },
    data() {
        this.PAGE_STATUS_MAP = PAGE_STATUS_MAP;
        this.STATUS_TEXT_MAP = {
            [PAGE_STATUS_MAP.PENDING]: '待处理',
            [PAGE_STATUS_MAP.PROCESSED]: '已处理',
            [PAGE_STATUS_MAP.REJECTED]: '已驳回',
            [PAGE_STATUS_MAP.PROCESSING]: '处理中',
        };
        this.DEFAULT_REMARK = '您的信息已提交，请耐心等待工作人员处理';
        this.STATUS_ICON_MAP = {
            [PAGE_STATUS_MAP.PENDING]: IMAGE_MAP.PAGE_PADDING_ICON,
            [PAGE_STATUS_MAP.PROCESSED]: IMAGE_MAP.PAGE_SUCCESS_ICON,
            [PAGE_STATUS_MAP.REJECTED]: IMAGE_MAP.PAGE_FAILED_ICON,
            [PAGE_STATUS_MAP.PROCESSING]: IMAGE_MAP.PAGE_PROCESSING_ICON,
        };
        this.submitdialogBtnConfig = {
            btns: [
                {
                    text: '取消',
                    handler: () => {
                        this.addition = '';
                        this.isAdditionDialogShow = false;
                    },
                },
                {
                    text: '确定',
                    handler: this.submitAddition,
                },
            ],
        };
        return {
            isAdditionDialogShow: false,
            addition: '',
        };
    },
    computed: {
        // eslint-disable-next-line max-len
        ...mapState(['remark', 'status', 'bizInfo', 'currentBizKey', 'isSubmitting', 'from', 'originBizKey', 'soid', 'entranceId', 'source', 'checkPhone']),
        ...mapGetters(['currentPageTitle', 'bizConfig', 'nextPageKey', 'headPageKey']),
        canAddInfo() {
            if (!this.bizInfo.config) {
                return this.status !== PAGE_STATUS_MAP.PENDING;
            }
            return this.status !== PAGE_STATUS_MAP.PENDING && this.bizInfo.config.showAdditionButton;
        },
        canEdit() {
            const { config = {} } = this.bizInfo;
            // 状态为【待处理】中 打开方式：端内打开
            if (this.status === PAGE_STATUS_MAP.PENDING && this.bizConfig.mustLoggedOn) {
                return true;
            }
            // 配置需要审核后，才可以走新逻辑【支持修改】
            if (config.needProcess) {
                if (PAGE_STATUS_MAP.REJECTED === this.status) {
                    return config.showNewFormInRejectStatus;
                }
            }
            return false;
        },
        canReFill() {
            // 有修改信息按钮 || 有from参数不展示重新填写按钮（有from的逻辑，不同于原逻辑）
            if (this.canEdit || this.from) {
                return false;
            }
            const { config = {} } = this.bizInfo;
            if (PAGE_STATUS_MAP.PROCESSED === this.status) {
                return config.showNewFormInPassStatus;
            }
            return false;
        },
        expired() {
            return this.status === PAGE_STATUS_MAP.EXPIRED;
        },
        uploaded() {
            return this.status === PAGE_STATUS_MAP.UPLOADED;
        },
        finished() {
            return this.status === PAGE_STATUS_MAP.FINISHED;
        },
        backButtonVisible() {
            return document.referrer && this.originBizKey && this.originBizKey !== 'undefined';
        },
    },
    methods: {
        ...mapMutations(['saveTicket']),
        ...mapActions(['setPageInfo', 'triggerMutate']),
        setPageTitle,
        onEditClickHandler() {
            this.saveTicket({
                code: 0,
                soid: '',
            });
            this.setPageInfo({});
        },
        async onReFillClickHandler() {
            await setInformationFinish({
                bizKey: this.currentBizKey,
            });
            this.saveTicket({
                code: 0,
                soid: '',
            });
            this.setPageInfo({});
        },
        onCloseClickHandler() {
            exitWebView();
        },
        async submitAddition() {
            if (!this.addition.trim()) {
                toast.error('请勿提交空信息');
                return;
            }
            let isAdditionSubmitSuccess = true;
            if (this.isSubmitting) {
                return;
            }
            this.triggerMutate({ isSubmitting: true });
            try {
                toast.loading();
                await postAddition({
                    bizKey: this.currentBizKey,
                    addition: this.addition,
                });
            } catch (e) {
                isAdditionSubmitSuccess = false;
            } finally {
                toast.hide();
            }
            this.isAdditionDialogShow = !isAdditionSubmitSuccess;
            if (isAdditionSubmitSuccess) {
                toast.success('提交成功');
                this.addition = '';
            } else {
                toast.error('提交失败，请重试');
            }
            this.triggerMutate({ isSubmitting: false });
        },
        backToService() {
            const { originBizKey, soid, source, entranceId } = this;
            const origin = document.referrer || location.origin.replace('collect', 'center');
            // 测试域名有中缀路径
            const infix = origin.includes('staging') ? 'ks-fe-csc-mobile/gefei/' : '';
            // eslint-disable-next-line
            location.href = `${origin}/${infix}/service/?enableWK=1&layoutType=4#/service-detail?bizKey=${originBizKey}&soid=${soid}&source=${source}&entranceId=${entranceId}`;
        },
    },
    watch: {
        currentPageTitle: {
            immediate: true,
            handler: 'setPageTitle',
        },
    },
};
</script>
<style lang='less' scoped>
.landing-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    .nav-back-button {
        position: absolute;
        top: 50%;
        left: 10px;
        width: 30px;
        height: 30px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        background-position: 50%;
        background-repeat: no-repeat;
        z-index: 1001;
        background-image: var(--csc-collect-icon-back);
        background-size: 100% auto;
    }
}
.landing {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 20px;
    &-info {
        flex: 1;
        min-height: 350px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 60px;
        > span + span {
            margin-top: 20px;
        }
        font-size: 16px;
        &-icon {
            width: 80px;
            height: 80px;
            > img {
                width: 100%;
                height: 100%;
            }
        }
        &-status {
            color: #222222;
        }
        &-tip {
            margin-top: 16px;
            padding: 4px 0;
            font-size: 13px;
            color: #9B9B9B;
            max-height: 40vh;
            overflow-y: auto;
            word-break: break-all;
            line-height: 1.3;
        }
        &-addition {
            margin-top: 16px;
            > a {
                text-decoration: none;
                color: #fe3666;
            }
        }
    }
    &-control {
        width: 100%;
        margin-bottom: 20px;
        > .sp-button + .sp-button {
            margin-top: 10px;
        }
    }
}
</style>
